export enum OrderLineStatus {
  All = 'ALL',
  Staged = 'Staged',
  Dispatched = 'Dispatched',
  Delivered = 'Delivered',
}
